import React from "react";
import { Row } from "antd";
import { BaseComponent } from "../../base/BaseComponent";
import "./Security.less";

export default class Security extends BaseComponent {
  render() {
    return (
      <>
        <div className="gx-mb-6">
          <h1 className="gx-text-center heading-big gx-mb-5">
            {this.lang.Security}
          </h1>
          <p className="text-medium gx-mb-5">{this.lang.SecurityIntroPara}</p>

          <Row className="security-row gx-text-center">
            {this.antd.colmd6(
              <div className="security-feature-card">
                <img src="/assets/images/shield.svg" alt="Secured" />
                <h1 className="heading-medium">
                  {this.lang.TwoFactorAuthHeading}
                </h1>
                <p className="text-small">{this.lang.TwoFactorAuthPara}</p>
              </div>
            )}

            {this.antd.colmd6(
              <div className="security-feature-card">
                <img src="/assets/images/ddos.svg" alt="DDOS Protection" />
                <h1 className="heading-medium">{this.lang.DDosHeading}</h1>
                <p className="text-small">{this.lang.DDosPara}</p>
              </div>
            )}

            {this.antd.colmd6(
              <div className="security-feature-card">
                <img src="/assets/images/folder.svg" alt="Offline Storage" />
                <h1 className="heading-medium">
                  {this.lang.Offline} {this.lang.Storage}
                </h1>
                <p className="text-small">{this.lang.OfflineStoragePara1}</p>
              </div>
            )}
            {this.antd.colmd6(
              <div className="security-feature-card">
                <img src="/assets/images/wallet.svg" alt="Offline Storage" />
                <h1 className="heading-medium">
                  {this.lang.Multisig} {this.lang.Wallet}
                </h1>
                <p className="text-small">{this.lang.MultisigWalletPara}</p>
              </div>
            )}
          </Row>
        </div>
      </>
    );
  }
}
